class sibling {
  constructor() {
    this.name= '',
    this.age= '',
    this.school= '',
    this.grade= ''
  }
}

export default sibling
